/**
 * The methods offerable right now, in Shopify's display order (card first, then cash on delivery).
 *
 * CARD is offered only when the store accepts it AND it mounted. When the store declares card but it cannot
 * mount, a store that also accepts COD degrades to COD rather than blocking the sale — the seller opted into
 * COD, so honouring it is the correct commercial outcome, not a way for the buyer to dodge an online payment.
 * Both unavailable ⇒ EMPTY, and the caller must say so instead of rendering an unfulfillable button.
 */
export function offerableMethods(enabled, cardStatus) {
    const out = [];
    if (enabled.includes('CARD') && cardStatus === 'ready')
        out.push('CARD');
    if (enabled.includes('COD'))
        out.push('COD');
    return out;
}
/**
 * The effective selection: the buyer's choice while it is still offerable, else the first offerable method
 * (the default), else `null` (nothing to offer). Re-deriving it on every render — rather than storing it — is
 * what makes a withdrawn method impossible to submit: the card probe resolving to `unavailable` re-pins the
 * selection to COD by itself, with no effect to remember to fire.
 */
export function resolveSelected(methods, chosen) {
    if (chosen && methods.includes(chosen))
        return chosen;
    return methods[0] ?? null;
}
//# sourceMappingURL=paymentMethods.js.map